export const getClientId = () => sessionStorage.getItem("client_id");
export const getRoomId = () => sessionStorage.getItem("room_id");
export const setClientId = (clientId: string) => sessionStorage.setItem("client_id", clientId);
export const setRoomId = (roomId: string) => sessionStorage.setItem("room_id", roomId);
